export default __webpack_public_path__ + "static/media/s2-grid3.c0f20b46.jpg";